import React, {Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon

// Custom Component
import useLoading from "../Loading/useLoading"
import CurrentDrawingTable from "./CurrentDrawingTable"

// Custom Style
import drawingRegisterStyle from '../../styles/jss/components/drawingRegister/drawingRegisterStyle'

// Fetch Data
// import {getLatestDrawing} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => drawingRegisterStyle(theme))

const CurrentDrawings = props => {
	const {annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()
	const dispatch = useDispatch()
	
	return (
		// console.log("Latest drawing data | Variable: latestDrawing (CurrentDrawings.js)"),
		// console.log(latestDrawing),

		// console.log("Latest drawing data (Redux) | Variable: latestDrawingRedux (CurrentDrawings.js)"),
		// console.log(latestDrawingRedux),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<CurrentDrawingTable 
					annotSaveChangeAction={annotSaveChangeAction}
					setAnnotSaveChangeAction={setAnnotSaveChangeAction}
				/>
			</div>
		</Fragment>
	)
}


export default CurrentDrawings